import uniq from 'lodash/uniq'

export const calcSumAmount = (item) => {
  const refund = calcSumRefundAmount(item)
  return (
    (item?.actualAmount !== null && item?.actualAmount >= 0 && item?.actualAmount !== ''
      ? item?.actualAmount
      : item.amount) - refund
  )
}

export const calcSumCorrectionAmount = (item) => {
  const refund = calcSumRefundAmount(item)
  return (
    (item?.actualAmount !== null && item?.actualAmount >= 0 && item?.actualAmount !== ''
      ? item?.actualAmount
      : item.correctedAmount || item.amount) - refund
  )
}

export const calcSumRefundAmount = (item) => item?.refund_items?.reduce((acc, refund) => acc + refund.amount, 0) || 0

export const calcImplSumAmount = (implementations) => {
  const implementationUnits = uniq(
    implementations
      .filter((implementation) => !implementation?.correctedAmount)
      .filter((implementation) => implementation.unit)
      .map((implementation) => implementation.unit)
  )
  const implementationAmount = implementations.reduce((acc, implementation) => {
    if (implementation.amount > 0 || implementation?.correctedAmount > 0) {
      const finalAmount = calcSumAmount(implementation)
      return acc + (implementation?.correctedAmount > 0 ? implementation?.correctedAmount : finalAmount)
    }
    return acc
  }, 0)
  return implementationUnits.length <= 1 ? implementationAmount : ''
}

export const priceNoVat = (item) => {
  let vat = 0
  if (item.vatType === 'include' && item.vatValue > 0 && item.price > 0) {
    vat = (item.price * item.vatValue) / (100 + item.vatValue)
  }
  return item.price - vat
}

export const correctedPriceNoVat = (item) => {
  let vat = 0
  if (item.vatType === 'include' && item.vatValue > 0 && item.correctedPrice > 0) {
    vat = (item.correctedPrice * item.vatValue) / (100 + item.vatValue)
  }
  return item.correctedPrice - vat
}

export const priceSumNoVat = (item) => {
  const finalAmount = calcSumAmount(item)
  if (item.vatType === 'include' && item.amount > 0 && item.vatValue > 0) {
    const sum = item.price * finalAmount
    const vat = (sum * item.vatValue) / (100 + item.vatValue)
    return sum - vat
  }
  return item.price * finalAmount
}

export const priceSumVat = (item) => {
  const finalAmount = calcSumAmount(item)
  if (item.vatType === 'up' && item.vatValue > 0 && item.price > 0 && item.amount > 0) {
    const sum = item.price * finalAmount
    const vat = (sum / 100) * item.vatValue
    return sum + vat
  }

  return item.price * finalAmount
}

export const sumNoVatByUnit = (implementations) =>
  implementations.reduce((acc, item) => {
    if (item.unit && item.price && item.amount) {
      if (!acc[item.unit]) {
        acc[item.unit] = {}
        acc[item.unit].sum = 0
        acc[item.unit].unit = item.unit
      }
      const finalAmount = calcSumAmount(item)
      if (item.vatType === 'include' && item.amount > 0 && item.vatValue > 0) {
        const sum = item.price * finalAmount
        const vat = (sum * item.vatValue) / (100 + item.vatValue)
        acc[item.unit].sum += sum - vat
      } else {
        acc[item.unit].sum += item.price * finalAmount
      }
    }
    return acc
  }, {})

export const sumNoVatByUnitWithCorrect = (implementations, estimateItems) =>
  implementations.reduce((acc, item) => {
    const estimateItem = estimateItems?.find((estimate) => estimate.id === item.application_item?.estimate_field?.id)
    const unit = item.correctedAmount && estimateItem ? estimateItem.unit : item.unit
    if (item.price && item.amount) {
      if (!acc[unit]) {
        acc[unit] = {}
        acc[unit].sum = 0
        acc[unit].unit = unit
      }
      const finalAmount = calcSumAmount(item)
      if (item.vatType === 'include' && item.amount > 0 && item.vatValue > 0) {
        const sum = item.price * finalAmount
        const vat = (sum * item.vatValue) / (100 + item.vatValue)
        acc[unit].sum += sum - vat
      } else {
        acc[unit].sum += item.price * finalAmount
      }
    }
    return acc
  }, {})

export const sumVatByUnitWithCorrect = (implementations, estimateItems) =>
  implementations.reduce((acc, item) => {
    const estimateItem = estimateItems?.find((estimate) => estimate.id === item.application_item?.estimate_field?.id)
    const unit = item.correctedAmount && estimateItem ? estimateItem.unit : item.unit
    if (unit && item.price && item.amount) {
      if (!acc[unit]) {
        acc[unit] = {}
        acc[unit].sum = 0
        acc[unit].unit = unit
      }

      const finalAmount = calcSumAmount(item)
      if (item.vatType === 'up' && item.vatValue > 0 && item.price > 0 && item.amount > 0) {
        const sum = item.price * finalAmount
        const vat = (sum / 100) * item.vatValue
        const result = sum + vat
        acc[unit].sum += result
      } else {
        acc[unit].sum += item.price * finalAmount
      }
    }
    return acc
  }, {})

export const sumVatByUnit = (implementations) =>
  implementations.reduce((acc, item) => {
    if (item.unit && item.price && item.amount) {
      if (!acc[item.unit]) {
        acc[item.unit] = {}
        acc[item.unit].sum = 0
        acc[item.unit].unit = item.unit
      }
      acc[item.unit].sum += priceSumVat(item)
    }
    return acc
  }, {})

// export const filterByWord = (phrase, search) => {
//   const searchKeys = search.split(' ').map((item) => item.toLowerCase())
//   return !!phrase.split(' ').find((item) =>
//     searchKeys.reduce((acc, key) => {
//       if (item.toLowerCase().includes(key) && key.length > 0) {
//         return true
//       }
//       return acc
//     }, false)
//   )
// }
